var chunkMapping = {
	"0": [
		4719
	],
	"3": [
		4211
	],
	"74": [
		5130
	],
	"153": [
		5209
	],
	"154": [
		5210
	],
	"157": [
		5213
	],
	"158": [
		5214
	],
	"159": [
		5215
	],
	"160": [
		5216
	],
	"161": [
		5217
	],
	"162": [
		5218
	],
	"163": [
		5219
	],
	"164": [
		5220
	],
	"165": [
		5221
	],
	"166": [
		5222
	],
	"167": [
		5223
	],
	"168": [
		5224
	],
	"169": [
		5225
	],
	"170": [
		5226
	],
	"171": [
		5227
	],
	"172": [
		5228
	],
	"173": [
		5229
	]
};
var idToExternalAndNameMapping = {
	"4211": [
		"default",
		"./nuorder-components",
		4064
	],
	"4719": [
		"default",
		"./Containers",
		3796
	],
	"5130": [
		"default",
		"./OrderlessInvoices",
		3796
	],
	"5209": [
		"default",
		"./AsyncEventTracker",
		3796
	],
	"5210": [
		"default",
		"./HostWrapper",
		3796
	],
	"5213": [
		"default",
		"./CheckoutV3",
		3796
	],
	"5214": [
		"default",
		"./CheckoutConfirmation",
		3796
	],
	"5215": [
		"default",
		"./ContactCreditCards",
		3796
	],
	"5216": [
		"default",
		"./AuditDialog",
		3796
	],
	"5217": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3796
	],
	"5218": [
		"default",
		"./InvoiceDialog",
		3796
	],
	"5219": [
		"default",
		"./PaymentDueModal",
		3796
	],
	"5220": [
		"default",
		"./PaymentModal",
		3796
	],
	"5221": [
		"default",
		"./PaymentHistory",
		3796
	],
	"5222": [
		"default",
		"./PaymentConfigurations",
		3796
	],
	"5223": [
		"default",
		"./PaymentPreferences",
		3796
	],
	"5224": [
		"default",
		"./ManagePaymentProcessing",
		3796
	],
	"5225": [
		"default",
		"./MobilePaymentsWrapper",
		3796
	],
	"5226": [
		"default",
		"./Challenge",
		3796
	],
	"5227": [
		"default",
		"./ManagePaymentMethods",
		3796
	],
	"5228": [
		"default",
		"./LightspeedReports",
		3796
	],
	"5229": [
		"default",
		"./ShippingPromotionsListContainer",
		3796
	]
};
var idToRemoteMap = {
	"4211": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 4064
		}
	],
	"4719": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5130": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5209": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5210": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5213": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5214": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5215": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5216": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5217": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5218": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5219": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5220": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5221": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5222": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5223": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5224": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5225": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5226": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5227": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5228": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5229": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}